<template>
    <div v-show="visible" class ="playlist-overlay" @wheel.stop>
        <div class="playlist-toolbar">
            <button class="playlist-btn"
                    @click="shufflePlaylist">
                🔀
            </button>

            <button class="playlist-btn"
                    @click="toggleRepeat"
                    :title="repeatTitle">
                {{ repeatIcon }}
            </button>

            <button class="playlist-btn"
                    @click="$emit('add-selected')"
                    title="선택한 파일 추가">
                ➕
            </button>

            <span class="playlist-count">
                {{ playlist.length }}
            </span>

            <!--<button class="playlist-btn close-btn"
                    @click="close">
                ✕
            </button>-->
        </div>
        <div class="playlist-body">
            <Draggable v-model="playlist"
                       item-key="name"
                       handle=".drag-handle"
                       animation="150">
                <template #item="{ element, index }">
                    <div class="playlist-item"
                         :class="{ active: index === playlistIndex }">
                        <span class="drag-handle">☰</span>
                        <MarqueeText :text="element.name" @click="play(index)" />
                        <button class="playlist-remove"
                                @click.stop="removePlaylistItem(index)">
                            🗑
                        </button>
                    </div>
                </template>
            </Draggable>
        </div>
    </div>
</template>

<script setup>
    import Draggable from 'vuedraggable'
    import { computed, ref } from 'vue'    
    import MarqueeText from "@/utils/MarqueeText.vue";
    import { useStore } from "vuex";

    const store = useStore();

    const playlist = computed({
        get: () => store.state.media.playlist,
        set: value => store.commit("media/setPlaylist",value)
    });
    const playlistIndex = computed(() => store.state.media.playlistIndex);
    const currentFileName = computed(() => store.state.media.mediaFile?.name ?? "");
    const repeatMode = computed(() => store.state.media.repeatMode);

    const emit = defineEmits([
        "play",
        'add-selected'
    ]);

    const visible = ref(false);

    function toggle() {
        visible.value = !visible.value;
    }

    function close() {
        visible.value = false;
    }

    defineExpose({
        toggle        
    });    

    const repeatIcon = computed(() => {
        switch (repeatMode.value) {
            case 0:
                return "🔁";
            case 1:
                return "🔂";
            default:
                return "➡";
        }
    });

    const repeatTitle = computed(() => {
        switch (repeatMode.value) {
            case 0: return "전체 반복";
            case 1: return "한 곡 반복";
            default: return "반복 안 함";
        }
    });

    function shufflePlaylist() {
        store.dispatch("media/shufflePlaylist");
    }

    async function removePlaylistItem(index) {
        await store.dispatch(
            "media/removePlaylist",
            index
        );
    }

    function toggleRepeat() {
        store.dispatch("media/setRepeatMode",(repeatMode.value + 1) % 3);
    }

    function play(index) {
        emit("play", index);
    }
</script>

<style scoped>
    .playlist-overlay {
    position: absolute;
    top: 10px;
    right: 55px;
    width: 320px;
    max-height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    background: rgba(0,0,0,.75);
    border-radius: 8px;
    z-index: 1000;
}

.playlist-toolbar {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-right: 20px;
    flex-shrink: 0;
}

.playlist-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.playlist-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    margin-bottom: 4px;
    border-radius: 6px;
    color: #ddd;
    cursor: pointer;
    transition: .15s;
}

    .playlist-item:hover {
        background: rgba(255,255,255,.08);
    }

    .playlist-item.active {
        background: rgba(25,118,210,.8);
        color: white;
    }

.drag-handle {
    flex: 0 0 auto;
    margin-right: 8px;
    cursor: grab;
    color: #999;
    user-select: none;
}

    .drag-handle:active {
        cursor: grabbing;
    }

    .playlist-name {
        overflow: hidden;
        white-space: nowrap;
    }

.playlist-remove {
    margin-left: 8px;
    border: none;
    background: transparent;
    color: #bbb;
    cursor: pointer;
    font-size: 16px;
}

    .playlist-remove:hover {
        color: #ff5555;
    }

.playlist-body {
    flex: 1;
    overflow-y: auto;
    min-height: 0; /* flex에서 매우 중요 */
}

.playlist-btn {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: rgba(255,255,255,.08);
    color: white;
    cursor: pointer;
}

    .playlist-btn:hover {
        background: rgba(255,255,255,.18);
    }

.playlist-count {
    margin-left: auto;
    color: #bbb;
    font-size: 13px;
}

.close-btn {
    width: 28px;
    height: 28px;
    padding: 0;
    font-size: 14px;
}

    @media (max-width: 768px) {
        .playlist-overlay {
            transform: scale(.82);
            transform-origin: top right;
        }
    }
</style>